export const navigation = {
  categories: [
    {
      id: 'women',
      name: 'Women',
      featured: [
        {
          name: 'New Arrivals',
          href: '/',
          imageSrc: 'https://rukminim2.flixcart.com/image/612/612/xif0q/top/c/v/t/s-d-16-angarkha-original-imahc7ha2tgxvaqw.jpeg?q=70',
          imageAlt: 'Models sitting back to back, wearing Basic Tee in black and bone.',
        },
        {
          name: 'Basic Tees',
          href: '/',
          imageSrc: 'https://rukminim2.flixcart.com/image/612/612/ku4ezrk0/top/g/s/1/xl-printed-top-fancify-original-imag7bb3yg9xx4yn.jpeg?q=70',
          imageAlt: 'Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.',
        },
      ],
      sections: [
        {
          id: 'bottom_wear',
          name: 'Bottom Wear',
          items: [
            { name: 'Formal Pants', id: 'formal_pants', href: '/women/bottom_wear/formal_pants' },
            { name: 'Cotton Pants', id: 'cotton_pants', href: '/women/bottom_wear/cotton_pants' },
            { name: 'Linen Pants', id: 'linen_pants', href: '/women/bottom_wear/linen_pants' },
            { name: 'Cargo', id: 'cargos', href: '/women/bottom_wear/cargos' },
            { name: 'Track Pants', id: 'track_pants', href: '/women/bottom_wear/track_pants' },
            { name: 'Jeans', id: 'jeans', href: '/women/bottom_wear/jeans' },
            { name: 'Skirts', id: 'skirts', href: '/women/bottom_wear/skirts' },
          ],
        },
        {
          id: 'blazer',
          name: 'Blazers',
          items: [
            { name: 'Blazers', id: 'blazers', href: '/women/blazer/blazers' },
            { name: 'Blazer Sets', id: 'blazers_sets', href: '/women/blazer/blazers_sets' },
          ],
        },
        {
          id: 'shirts',
          name: 'Shirts',
          items: [
            { name: 'Formal Shirts', id: 'formal_shirts', href: '/women/shirts/formal_shirts' },
            { name: 'Satin Shirts', id: 'satin_shirts', href: '/women/shirts/satin_shirts' },
            { name: 'Hidden Button Shirts', id: 'hidden_button_shirts', href: '/women/shirts/hidden_button_shirts' },
          ],
        },
        {
          id: 'tops',
          name: 'Tops',
          items: [
            { name: 'Tanic Top', id: 'tanic_tops', href: '/women/tops/tanic_tops' },
            { name: 'Tank Top', id: 'tank_tops', href: '/women/tops/tank_tops' },
            { name: 'Peplum Top', id: 'peplum_tops', href: '/women/tops/peplum_tops' },
            { name: 'Crop Tops', id: 'crop_tops', href: '/women/tops/crop_tops' },
          ],
        },
        {
          id: 'kurtis',
          name: 'Kurtis',
          items: [
            { name: 'Office Wear', id: 'office_wear_kurtis', href: '/women/kurtis/office_wear_kurtis' },
            { name: 'A-Line Kurtis', id: 'a_line_kurtis', href: '/women/kurtis/a_line_kurtis' },
            { name: 'Kalamkari Kurti', id: 'kalamkari', href: '/women/kurtis/kalamkari' },
          ],
        },
        {
          id: 'swimmingsuit',
          name: 'Swimming Suit',
          items: [
            { name: 'One Piece', id: 'one_piece', href: '/women/swimming_costume/one_piece' },
            { name: 'Bikini', id: 'bikini', href: '/women/swimming_costume/bikini' },
            { name: 'Swim Sets', id: 'swim_sets', href: '/women/swimming_costume/swim_sets' },
          ],
        },
        {
          id: 'tummytucker',
          name: 'Tummytucker',
          items: [
            { name: 'High Waist', id: 'high_waist', href: '/women/tummytucker/high_waist' },
            { name: 'Full Body', id: 'full_body', href: '/women/tummytucker/full_body' },
            { name: 'Waist Trainer', id: 'waist_trainer', href: '/women/tummytucker/waist_trainer' },
          ],
        },
      ],
    },
  ],
  pages: [
    { name: '', id: '/' },
    { name: '', id: '/' },
  ],
};
